export default __webpack_public_path__ + "static/media/call-inbound.e382a73f.svg";